import * as React from 'react';
import { compose, setDisplayName } from 'recompose';
import { translate } from 'react-i18next';
import { TranslateProps } from 'util/i18n';
import { skin, OemProps } from 'ui/styles/skin';
import { DeviceIndex } from 'types';
import { ReportDevice } from 'logic/reports/ReportDevice';
import { SelectedCamera } from './SelectedCamera';
const { Transition, animated } = require('react-spring');

import './SelectedCameraList.css';

export type OwnProps = {
    idModifier?: string;
    selected: ReadonlyArray<ReportDevice>;
    onRemove: (deviceIndex: DeviceIndex) => void;
};

const deviceIndexAscending = (a: ReportDevice, b: ReportDevice) => a.deviceIndex - b.deviceIndex;

const staticStyles = {
    exit: {
        opacity: 0,
        height: 0,
    },
    enter: {
        opacity: 1,
        height: 30,
    },
};

const RawSelectedCameraList = ({ idModifier, selected, onRemove, styles, t }: OwnProps & OemProps & TranslateProps) => {
    const sortedItems = selected && [ ...selected ].sort(deviceIndexAscending) || [];
    const keys = sortedItems.map(item => `${item.deviceIndex}`);
    return (
        <ul id={ `edit-report-selected-${idModifier ? idModifier : ''}cameras` }>
            <Transition
                native={ true }
                keys={ keys }
                from={ staticStyles.exit }
                enter={ staticStyles.enter }
                leave={ staticStyles.exit }
            >
                { sortedItems.map(({ deviceIndex }) => (style: React.CSSProperties) =>
                    <animated.li style={ style }>
                        <SelectedCamera
                            id={ `edit-report-selected-${idModifier ? idModifier : ''}cameras-${deviceIndex}` }
                            deviceIndex={ deviceIndex }
                            onRemove={ () => onRemove(deviceIndex) }
                            t={ t }
                            styles={ styles }
                        />
                    </animated.li>
                ) }
            </Transition>
        </ul>
    );
};

export const SelectedCameraList = compose<OwnProps & TranslateProps, OwnProps>(
    setDisplayName('SelectedCameraList'),
    translate(),
    skin,
)(RawSelectedCameraList);



// WEBPACK FOOTER //
// ./src/ui/pages/designer/sections/cameras/SelectedCameraList.tsx